<template>
    <div ref="confirmButtonRef" class="confirm-button">
        <e-button v-if="!justIcon && !confirming && !loading" v-bind="$attrs" outlined @click="confirming = true">
            <slot>
                <e-icon icon="trash-alt" />
            </slot>
        </e-button>
        <div v-else-if="justIcon && !confirming && !loading">
            <slot>
                <e-icon icon="trash-alt" class="is-clickable" @click.stop="confirming = true" />
            </slot>
        </div>

        <e-button v-else v-bind="$attrs" :type="confirmType" :loading="loading" @click.stop="danger">
            <slot name="danger">Remove</slot>
        </e-button>
    </div>
</template>

<script setup>
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';

defineProps({
    loading: Boolean,
    justIcon: {
        type: Boolean,
        default: false,
    },
    confirmType: {
        type: String,
        default: 'is-danger',
    },
});

const confirming = ref(false);
const confirmButtonRef = ref(null);

onClickOutside(confirmButtonRef, () => {
    if (confirming.value) confirming.value = false;
});

const emit = defineEmits(['confirmed']);

const danger = () => {
    emit('confirmed');
    confirming.value = false;
};
</script>
